import PropTypes from "prop-types"

// material-ui
import { useTheme } from "@mui/material/styles"
import { Avatar, Box, ButtonBase, Typography } from "@mui/material"

// project imports
import LogoSection from "../LogoSection"
import ProfileSection from "./ProfileSection"
import NotificationSection from "./HeaderNotification/HeaderNotificationIndex"

// assets
import { IconMenu2 } from "@tabler/icons"
import LogoEcg from "../../../ui-component/LogoEcg"

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
  const theme = useTheme()

  return (
    <>
      {/* logo & toggler button */}
      <Box
        sx={{
          width: 228,
          display: "flex",
          alignItems: "center",
          gap: "2rem",
          [theme.breakpoints.down("md")]: {
            width: "auto",
          },
        }}
      >
        <ButtonBase sx={{ borderRadius: "12px", overflow: "hidden" }}>
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              transition: "all .2s ease-in-out",
              background: theme.palette.secondary.light,
              color: theme.palette.secondary.dark,
              "&:hover": {
                background: theme.palette.secondary.dark,
                color: theme.palette.secondary.light,
              },
            }}
            onClick={handleLeftDrawerToggle}
            color="inherit"
          >
            <IconMenu2 stroke={1.5} size="1.3rem" />
          </Avatar>
        </ButtonBase>
        <Box
          component="span"
          sx={{ display: { xs: "none", md: "block" }, flexGrow: 1 }}
        >
          {/* <LogoEcg /> */}
          <Typography sx={{ fontSize: 20, color: "black", fontWeight: "500" }}>
          Garde ECG
          </Typography>
        </Box>
      </Box>

      <Box sx={{ flexGrow: 1 }} />

      {/* Notification  */}
      {/* <NotificationSection /> */}
      {/* Profile */}
      {/* <ProfileSection /> */}
    </>
  )
}

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func,
}

export default Header
